var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.nodeInfo)?_c('t-node',{attrs:{"info":_vm.nodeInfo}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }